import { Component, Inject, ViewChild } from '@angular/core';
import { MatDialogContent, MatDialogActions, MatDialogTitle, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { UploadFilesComponent } from "../helpers/upload-files/upload-files.component";
import { MatButton } from "@angular/material/button";
import { pDescription } from '../../interfaces/pDescription';

@Component({
  selector: 'app-add-file-dialog',
  standalone: true,
  imports: [MatDialogContent, MatDialogActions, UploadFilesComponent, MatDialogTitle, MatButton],
  templateUrl: './add-file-dialog.component.html',
  styleUrl: './add-file-dialog.component.scss'
})
export class AddFileDialogComponent {
  isLoading: boolean = false;
  @ViewChild('fileUpload') fileUpload!: UploadFilesComponent;
  constructor(
    public dialogRef: MatDialogRef<AddFileDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { description: pDescription; pTicketID : number }
  ) { }
  onUpdateDescription() {
    this.isLoading = true;
    let ticket = {
      id: this.data.pTicketID,
      pct_initialdescription: this.data.description
    }
    console.log(ticket);
    if (this.fileUpload.files.length > 0) {
      this.fileUpload.onFileUpload(ticket).subscribe(results => {


        this.dialogRef.close("files added");
        //this.pDescriptionAddedEmitter.emit();
        this.isLoading = false;
      });
    }
  }
  onCancel(): void {
    this.dialogRef.close();
  }

}
